/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type ClientRow = {
  __typename?: 'ClientRow';
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  fiduciaryName?: Maybe<Scalars['String']['output']>;
};

export type CorrectFilingInput = {
  correctionNote: Scalars['String']['input'];
  filingId: Scalars['String']['input'];
};

export type CorrectRejectedFilingInput = {
  correctionNote: Scalars['String']['input'];
  filingId: Scalars['String']['input'];
};

export type FilingReview = {
  __typename?: 'FilingReview';
  filingId: Scalars['String']['output'];
};

export type FirmFilingRow = {
  __typename?: 'FirmFilingRow';
  filingId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type HandInStatementInput = {
  fileRef: Scalars['String']['input'];
  filingId: Scalars['String']['input'];
  statementId: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  correctFiling: MutationResponse;
  correctRejectedFiling: MutationResponse;
  handInStatement: MutationResponse;
  openFiling: MutationResponse;
  publishTaxRules: MutationResponse;
  recordApproval: MutationResponse;
  registerClient: MutationResponse;
  registerFilingCredential: MutationResponse;
  uploadFile: UploadTicket;
};


export type MutationCorrectFilingArgs = {
  input: CorrectFilingInput;
};


export type MutationCorrectRejectedFilingArgs = {
  input: CorrectRejectedFilingInput;
};


export type MutationHandInStatementArgs = {
  input: HandInStatementInput;
};


export type MutationOpenFilingArgs = {
  input: OpenFilingInput;
};


export type MutationPublishTaxRulesArgs = {
  input: PublishTaxRulesInput;
};


export type MutationRecordApprovalArgs = {
  input: RecordApprovalInput;
};


export type MutationRegisterClientArgs = {
  input: RegisterClientInput;
};


export type MutationRegisterFilingCredentialArgs = {
  input: RegisterFilingCredentialInput;
};


export type MutationUploadFileArgs = {
  input: UploadFileInput;
};

export type MutationError = {
  __typename?: 'MutationError';
  message?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type OpenFilingInput = {
  clientId: Scalars['String']['input'];
  filingCredentialId: Scalars['String']['input'];
  filingId: Scalars['String']['input'];
  taxRuleSetId: Scalars['String']['input'];
};

export type PublishTaxRulesInput = {
  ruleVersion: Scalars['String']['input'];
  taxRuleSetId: Scalars['String']['input'];
  taxYear: Scalars['Float']['input'];
};

export type Query = {
  __typename?: 'Query';
  findClients: Array<ClientRow>;
  findFirmFilings: Array<FirmFilingRow>;
  uploadFileStatus?: Maybe<UploadFileStatus>;
  viewFiling?: Maybe<FilingReview>;
};


export type QueryUploadFileStatusArgs = {
  fileId: Scalars['String']['input'];
};


export type QueryViewFilingArgs = {
  filingId?: InputMaybe<Scalars['String']['input']>;
};

export type RecordApprovalInput = {
  approvalId: Scalars['String']['input'];
  filingId: Scalars['String']['input'];
};

export type RegisterClientBeneficiariesInput = {
  beneficiaryName: Scalars['String']['input'];
};

export type RegisterClientInput = {
  beneficiaries: Array<InputMaybe<RegisterClientBeneficiariesInput>>;
  clientId: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  fiduciaryName: Scalars['String']['input'];
};

export type RegisterFilingCredentialInput = {
  environment: Scalars['String']['input'];
  filingCredentialId: Scalars['String']['input'];
  transmitterId: Scalars['String']['input'];
};

export type UploadFileInput = {
  byteSize: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type UploadFileStatus = {
  __typename?: 'UploadFileStatus';
  byteSize: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type UploadTicket = {
  __typename?: 'UploadTicket';
  fileId: Scalars['ID']['output'];
  ticket: Scalars['String']['output'];
};

export type FindClientsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindClientsQueryQuery = { __typename?: 'Query', findClients: Array<{ __typename: 'ClientRow', clientId: string, clientName?: string | null, fiduciaryName?: string | null }> };

export type FindFirmFilingsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindFirmFilingsQueryQuery = { __typename?: 'Query', findFirmFilings: Array<{ __typename: 'FirmFilingRow', filingId: string, status?: string | null }> };

export type ViewFilingQueryQueryVariables = Exact<{
  filingId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewFilingQueryQuery = { __typename?: 'Query', viewFiling?: { __typename: 'FilingReview', filingId: string } | null };

export type UploadFileStatusQueryQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type UploadFileStatusQueryQuery = { __typename?: 'Query', uploadFileStatus?: { __typename: 'UploadFileStatus', id: string, fileName: string, contentType: string, byteSize: number, checksum: string, status: string } | null };

export type RegisterClientMutationMutationVariables = Exact<{
  input: RegisterClientInput;
}>;


export type RegisterClientMutationMutation = { __typename?: 'Mutation', registerClient: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type PublishTaxRulesMutationMutationVariables = Exact<{
  input: PublishTaxRulesInput;
}>;


export type PublishTaxRulesMutationMutation = { __typename?: 'Mutation', publishTaxRules: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type RegisterFilingCredentialMutationMutationVariables = Exact<{
  input: RegisterFilingCredentialInput;
}>;


export type RegisterFilingCredentialMutationMutation = { __typename?: 'Mutation', registerFilingCredential: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type OpenFilingMutationMutationVariables = Exact<{
  input: OpenFilingInput;
}>;


export type OpenFilingMutationMutation = { __typename?: 'Mutation', openFiling: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type HandInStatementMutationMutationVariables = Exact<{
  input: HandInStatementInput;
}>;


export type HandInStatementMutationMutation = { __typename?: 'Mutation', handInStatement: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type CorrectFilingMutationMutationVariables = Exact<{
  input: CorrectFilingInput;
}>;


export type CorrectFilingMutationMutation = { __typename?: 'Mutation', correctFiling: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type RecordApprovalMutationMutationVariables = Exact<{
  input: RecordApprovalInput;
}>;


export type RecordApprovalMutationMutation = { __typename?: 'Mutation', recordApproval: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type CorrectRejectedFilingMutationMutationVariables = Exact<{
  input: CorrectRejectedFilingInput;
}>;


export type CorrectRejectedFilingMutationMutation = { __typename?: 'Mutation', correctRejectedFiling: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type UploadFileMutationMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type UploadFileMutationMutation = { __typename?: 'Mutation', uploadFile: { __typename: 'UploadTicket', fileId: string, ticket: string } };


export const FindClientsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindClientsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findClients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"fiduciaryName"}}]}}]}}]} as unknown as DocumentNode<FindClientsQueryQuery, FindClientsQueryQueryVariables>;
export const FindFirmFilingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindFirmFilingsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findFirmFilings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"filingId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<FindFirmFilingsQueryQuery, FindFirmFilingsQueryQueryVariables>;
export const ViewFilingQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewFilingQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewFiling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"filingId"}}]}}]}}]} as unknown as DocumentNode<ViewFilingQueryQuery, ViewFilingQueryQueryVariables>;
export const UploadFileStatusQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UploadFileStatusQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFileStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"byteSize"}},{"kind":"Field","name":{"kind":"Name","value":"checksum"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UploadFileStatusQueryQuery, UploadFileStatusQueryQueryVariables>;
export const RegisterClientMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterClientMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterClientInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RegisterClientMutationMutation, RegisterClientMutationMutationVariables>;
export const PublishTaxRulesMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishTaxRulesMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublishTaxRulesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishTaxRules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PublishTaxRulesMutationMutation, PublishTaxRulesMutationMutationVariables>;
export const RegisterFilingCredentialMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterFilingCredentialMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterFilingCredentialInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerFilingCredential"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RegisterFilingCredentialMutationMutation, RegisterFilingCredentialMutationMutationVariables>;
export const OpenFilingMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OpenFilingMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenFilingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openFiling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OpenFilingMutationMutation, OpenFilingMutationMutationVariables>;
export const HandInStatementMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HandInStatementMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HandInStatementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"handInStatement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<HandInStatementMutationMutation, HandInStatementMutationMutationVariables>;
export const CorrectFilingMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CorrectFilingMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CorrectFilingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correctFiling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CorrectFilingMutationMutation, CorrectFilingMutationMutationVariables>;
export const RecordApprovalMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordApprovalMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordApprovalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordApproval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RecordApprovalMutationMutation, RecordApprovalMutationMutationVariables>;
export const CorrectRejectedFilingMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CorrectRejectedFilingMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CorrectRejectedFilingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correctRejectedFiling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CorrectRejectedFilingMutationMutation, CorrectRejectedFilingMutationMutationVariables>;
export const UploadFileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}}]}}]}}]} as unknown as DocumentNode<UploadFileMutationMutation, UploadFileMutationMutationVariables>;